import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function OrderBump() {
  const features = ['Portada personalizada con espacio para foto y nombre', 'Carta de dedicatoria del familiar o del profesional', '6 estaciones de vida con disparadores emocionales profundos', 'Preguntas diseñadas para que nunca haya "no sé qué escribir"', 'La página "El Puente" para completar entre paciente y familiar juntos', 'El cierre final con la frase que resume toda una vida'];
  return <section className="py-16 bg-gradient-to-r from-purple-50 to-pink-50" data-id="element-166">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-168">
          <div className="bg-white rounded-xl shadow-xl p-8 border-4 border-purple-300" data-id="element-169">
            <p className="text-amber-600 font-bold text-sm uppercase tracking-wide mb-4" data-id="element-170">
              ⚡ ANTES DE CONFIRMAR TU COMPRA — AGREGÁ ESTO AL PEDIDO:
            </p>

            <p className="text-lg text-gray-700 mb-6" data-id="element-171">
              ¿Trabajás con pacientes con deterioro cognitivo y querés sumar la
              herramienta más poderosa para la memoria autobiográfica?
            </p>

            <div className="bg-gradient-to-r from-amber-100 to-yellow-100 p-6 rounded-lg mb-6" data-id="element-172">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-173">
                💛 "HISTORIAS DE MI PUÑO Y LETRA"
              </h3>
              <p className="text-lg font-semibold text-amber-800 mb-4" data-id="element-174">
                La herramienta definitiva de Terapia de Reminiscencia
              </p>
              <p className="text-gray-700 mb-4" data-id="element-175">
                Un cuadernillo guiado para que el paciente escriba su historia
                de vida con su propio puño y letra. Diseñado como herramienta de
                Terapia de Reminiscencia para trabajar la memoria
                autobiográfica, la identidad y el vínculo familiar.
              </p>
            </div>

            <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-176">
              ¿Qué tiene adentro?
            </h4>

            <ul className="space-y-3 mb-6" data-id="element-177">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-178">
                  <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-179" />
                  <span className="text-gray-700" data-id="element-180">{feature}</span>
                </li>)}
            </ul>

            <p className="text-gray-700 mb-6 italic" data-id="element-181">
              Para el profesional que lo usa en sesión es mucho más que un
              cuadernillo. Es una sesión de reminiscencia lista para usar que el
              paciente puede continuar en casa entre encuentros.
            </p>

            <div className="bg-purple-100 border-2 border-purple-400 rounded-lg p-6 text-center" data-id="element-182">
              <p className="text-xl font-bold text-gray-900 mb-2" data-id="element-183">
                ✅ Sumar "Historias de mi Puño y Letra" por solo $9.000 ARS más
              </p>
              <p className="text-lg text-purple-800 font-semibold" data-id="element-184">
                (Total del pedido: $28.990 ARS)
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}